/** Firestore collections */
export const COL_SALES_TRANSACTIONS = "sales_transactions";
export const COL_UPLOAD_LOGS = "upload_logs";
export const COL_UPLOAD_ERRORS = "upload_errors";
export const COL_WEEKLY_IMPORTS = "weekly_imports";
/** Monthly bucket for chunked weekly sales files. */
export const COL_SALES_IMPORT_MONTHS = "sales_import_months";
export const SALES_IMPORT_LINE_CHUNKS_SUB = "lineChunks";
/** Target max serialized size per chunk doc (bytes). */
/** Stay under Firestore 1 MiB doc limit (serialized rows array). */
export const LINE_CHUNK_TARGET_BYTES = 280000;
/** Hard cap on rows per chunk doc (30k/week → ~25 chunk reads). */
export const LINE_CHUNK_MAX_ROWS = 1200;

export const BATCH_WRITE_SIZE = 500;
/** getAll() refs per duplicate pre-check batch (optional; weekly upload skips this). */
export const DUPLICATE_CHECK_CHUNK = 100;
/** Max rows to persist to upload_errors per upload. */
export const MAX_PERSIST_UPLOAD_ERRORS = 200;
export const PREVIEW_ROW_LIMIT = 50;
export const PREVIEW_PAGE_SIZE = 25;
export const RECORDS_PAGE_SIZE = 50;

/** Expected SQL export columns (case-insensitive match). */
export const EXPECTED_COLUMNS = [
  "Voucher Type",
  "Voucher No",
  "Bill No",
  "Trans Date",
  "m Voucher No",
  "Customer Name",
  "Employee Name",
  "Name Staff Name",
  "Item Group",
  "BrandName",
  "Part No",
  "Alias",
  "Item Name",
  "Product ID",
  "Qty",
  "Unit Price",
  "MRP",
  "Discount",
  "Discount Am",
  "Amount",
  "Bill Amount",
  "profitpercent",
  "workstationid",
  "BranchID",
];

export const DUPLICATE_MODES = {
  SKIP: "skip",
  UPDATE: "update",
  REPLACE: "replace",
};

export const IMPORT_MODES = {
  WEEKLY: "weekly",
  MONTHLY: "monthly",
};

export const UPLOAD_STATUS = {
  IDLE: "idle",
  PARSING: "parsing",
  VALIDATING: "validating",
  CHECKING_DUPLICATES: "checking_duplicates",
  READY: "ready",
  UPLOADING: "uploading",
  COMPLETE: "complete",
  ERROR: "error",
};
